import * as React from "react";
const autobind = require("class-autobind").default;
import { logger } from "@lib/common";
import { InputGroup } from "../../form/input.group/index";
import { Input } from "../../form/input/index";
import { RotateLoader } from "../../loaders/rotate/index";
export class FieldSubdomain extends React.Component {
    constructor(props) {
        super(props);
        autobind(this);
        this.state = {
            loading: false,
        };
        this.start_validating = false;
    }
    validate(subdomain) {
        if (!subdomain.match(/^[A-Za-z0-9](?:[A-Za-z0-9-]{2,61}[A-Za-z0-9])?$/) ||
            subdomain.length <= 3 ||
            subdomain.indexOf(".") !== -1) {
            logger.info("VALIDTE ERROR");
            this.props.onCheckCallback("Invalid sub-domain name. Sub-domains must start and end letters or numbers, be at least 4 characters and only contain the dashes in between ( - )");
            return false;
        }
        this.props.onCheckCallback("");
        return true;
    }
    onChange(e) {
        const { restaurant_id, website_id } = this.props;
        const subdomain = e.target.value;
        this.props.onChange(subdomain);
        this.validate(subdomain);
        if (!this.validate(subdomain)) {
            this.setState({ loading: false });
        }
        if (subdomain.length > 3) {
            this.start_validating = true;
        }
        if (this.timer) {
            clearTimeout(this.timer);
        }
        if (this.start_validating && this.validate(subdomain)) {
            this.setState({ loading: true });
            this.timer = setTimeout(async () => {
                try {
                    const data = await this.props.checkDomain({ subdomain, restaurant_id, website_id });
                    this.props.onCheckCallback(data.outcome === 1 ? data.message : "");
                }
                catch (e) {
                    this.props.onCheckCallback("Error validating sub-domain name, please try re-entering the name");
                    logger.captureException(e);
                }
                this.setState({ loading: false });
            }, 1500);
        }
        else {
            this.setState({ loading: false });
        }
    }
    render() {
        return (React.createElement(InputGroup, { side: "right", iconHtml: this.state.loading ?
                React.createElement(RotateLoader, { size: 2, color: "white" }) :
                React.createElement("span", null, this.props.base_domain) },
            React.createElement(Input, { required: true, onChange: this.onChange, placeholder: "Enter a name to check availability", value: this.props.value })));
    }
}
//# sourceMappingURL=index.js.map